import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { AppState } from "store";
import onboardMachine from "api/handlers/machine/onboardMachine";
import { enqueueSnackbar } from "notistack";
import i18n from "localization";
import { refetchMachinesSilent } from "store/machinesList/actions";
import appUrls from "shared/appUrls";
import { NavigateFunction } from "react-router-dom";
import { prepareActions } from "store/helpers";
import { EActions, ICreateMachineList } from "./type";
import getDevices from "api/handlers/device/getDevices";
import { getPlacements } from "api/handlers/placement/getPlacements";
import getSensorTypes from "api/handlers/getSensorTypes";
import getChannelsBySerialUid from "api/handlers/channel/getChannelsBySerialUid";
import getAudioChunkTypes from "api/handlers/getAudioChunkTypes";

export const path = "createMachine";

const actionData = [
  [EActions.setOpenModal, "openModal"],
  [EActions.setMachine, "machine"],
  [EActions.setDevices, "devices"],
  [EActions.setPlacements, "placements"],
  [EActions.setLoading, "loading"],
  [EActions.setSensorTypes, "sensorTypes"],
  [EActions.setLoadingSensorTypes, "loadingSensorTypes"],
  [EActions.setChannels, "channels"],
  [EActions.setLoadingChannels, "loadingChannels"],
  [EActions.setAudioChunkTypes, "audioChunkTypes"],
  [EActions.setLoadingAudioChunkTypes, "loadingAudioChunkTypes"],
];

const actions = prepareActions<ICreateMachineList, EActions>(actionData, path);

export default actions;

export const postMachine =
  (obj: any, history: NavigateFunction) =>
  async (dispatch: ThunkDispatch<AppState, void, Action> | any) => {
    try {
      const res = await onboardMachine(obj);
      if (res) {
        history(appUrls.machines.detailPlacements(res.id));
        enqueueSnackbar(i18n.t("form.onboarding.message.success"));
        dispatch(refetchMachinesSilent());
      }
    } catch (err: any) {
      enqueueSnackbar(
        i18n.t("form.onboarding.message.error", {
          error: err && err.message,
        })
      );
    }
  };

export const fetchMachineRelatedData =
  ({ project, machine }: any) =>
  async (dispatch: ThunkDispatch<{}, {}, Action<EActions>>, getState: any) => {
    dispatch(actions[EActions.setLoading](true));
    try {
      const devices = await getDevices(
        1,
        9999,
        undefined,
        undefined,
        undefined,
        project,
        false
      );
      const placements = await getPlacements({ machineIds: machine });
      dispatch(actions[EActions.setDevices](devices));
      dispatch(actions[EActions.setPlacements](placements?.results));
      dispatch(actions[EActions.setLoading](false));
    } catch (error) {
      dispatch(actions[EActions.setLoading](false));
    }
  };

export const fetchSensorTypes =
  () =>
  async (dispatch: ThunkDispatch<{}, {}, Action<EActions>>, getState: any) => {
    dispatch(actions[EActions.setLoadingSensorTypes](true));
    try {
      const sensorTypes = await getSensorTypes();
      dispatch(
        actions[EActions.setSensorTypes]({
          results: sensorTypes,
        })
      );
      dispatch(actions[EActions.setLoadingSensorTypes](false));
    } catch (error) {
      dispatch(actions[EActions.setLoadingSensorTypes](false));
    }
  };
export const fetchChannels =
  ({ deviceUid }: { deviceUid?: string | null }) =>
  async (dispatch: ThunkDispatch<{}, {}, Action<EActions>>, getState: any) => {
    dispatch(actions[EActions.setLoadingChannels](true));
    try {
      if (deviceUid) {
        const channels = await getChannelsBySerialUid(deviceUid);
        dispatch(actions[EActions.setChannels](channels));
      } else {
        dispatch(actions[EActions.setChannels]({ data: [] }));
      }
      dispatch(actions[EActions.setLoadingChannels](false));
    } catch (error) {
      dispatch(actions[EActions.setLoadingChannels](false));
    }
  };

export const fetchAudioChunkTypes =
  () =>
  async (dispatch: ThunkDispatch<{}, {}, Action<EActions>>, getState: any) => {
    dispatch(actions[EActions.setLoadingAudioChunkTypes](true));
    try {
      const audioChunkTypes = await getAudioChunkTypes();
      dispatch(actions[EActions.setAudioChunkTypes](audioChunkTypes));
      dispatch(actions[EActions.setLoadingAudioChunkTypes](false));
    } catch (error) {
      dispatch(actions[EActions.setLoadingAudioChunkTypes](false));
    }
  };
